import ApiService from '@/common/api.service.js'
import AuthService from '@/common/auth.service'
import JwtService from '@/common/jwt.service'
// import error_filter from '@/common/error.filter'
import router from '@/router'
import {
  LOGIN,
  LOGOUT,
  REGISTER_COMPANY,
  START_EMPLOYEE_REGISTRATION_BY_COMPANY,
  COMPLETE_EMPLOYEE_REGISTRATION_BY_COMPANY,
  REGISTER_EMPLOYEE_BY_INVITATION,
  EMPLOYEE_FETCH,
  EMPLOYEE_UPDATE,
  CHECK_AUTH,
  USER_DATA_UPDATE,
  USER_DATA_FETCH,
  USER_BANK_CARD_CREATE,
  USER_BANK_CARD_UPDATE,
  USER_BANK_ACCOUNT_CREATE,
  USER_BANK_ACCOUNT_UPDATE
} from '../action.types'
import {
  SET_TOKEN,
  SET_USER_DATA,
  PURGE_AUTH,
  SET_EMPLOYEE_DATA,
  SET_USER_BANK_ACCOUNT
} from '../mutations.types'

export default {
  async [LOGIN](context, credentials) {
    const bypass_credentials = {
      'username': credentials.username.toLowerCase(),
      'password': credentials.password
    }
    await AuthService.login(bypass_credentials)
      .then(({
        data
      }) => {
        context.commit(SET_TOKEN, data.token)
      })
      .catch(({
        response
      }) => {
        context.commit(PURGE_AUTH)
        credentials.notify({
          title: 'Не удалось войти',
          text: response.data[Object.keys(response.data)[0]][0]
        })
      })
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH)
  },
  async [REGISTER_COMPANY](context, payload) {
    await AuthService.registerCompany(payload)
  },
  async [START_EMPLOYEE_REGISTRATION_BY_COMPANY](context, payload) {
    await AuthService.startEmployeeRegistrationByCompany(payload)
      .then((response) => {
        payload.notify({
          title: 'Сотрудник успешно зарегистрирован',
          text: 'После регистрации всех сотрудников обновите страницу'
        })
      })
  },
  async [COMPLETE_EMPLOYEE_REGISTRATION_BY_COMPANY](context, payload) {
    await AuthService.completeEmployeeRegistrationByCompany(payload)
      .then((response) => {
        context.commit(PURGE_AUTH)
        context.commit(SET_TOKEN, response.data.authorization_token)
      })
  },
  async [REGISTER_EMPLOYEE_BY_INVITATION](context, payload) {
    await AuthService.registerEmployeeByInvitation(payload)
      .then((response) => {
        context.commit(PURGE_AUTH)
        context.commit(SET_TOKEN, response.data.authorization_token)
      })
  },
  async [CHECK_AUTH](context) {
    if (JwtService.getToken()) {
      if (!context.getters.currentUser.id) {
        ApiService.setHeader()
        await context.dispatch(USER_DATA_FETCH)
      }
    } else {
      context.commit(PURGE_AUTH)
    }
  },
  async [EMPLOYEE_FETCH](context, payload) {
    await AuthService.getEmployeeData(payload)
      .then(({
        data
      }) => {
        context.commit(SET_EMPLOYEE_DATA, data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  async [EMPLOYEE_UPDATE](context, payload) {
    await AuthService.updateEmployeeData(payload.id, payload)
      .then(({
        data
      }) => {
        payload.notify({
          title: 'Успешно',
          text: 'Данные успешно сохранены'
        })
        context.dispatch(USER_DATA_FETCH)
      })
      .catch(({
        response
      }) => {
        payload.notify({
          title: 'Не удалось изменить данные',
          text: response.data.error
        })
      })
  },
  async [USER_DATA_FETCH](context) {
    await AuthService.getUserData()
      .then(({
        data
      }) => {
        context.commit(SET_USER_DATA, data)
        if (context.getters.currentRoles.includes('EMPLOYEE')) {
          context.dispatch(EMPLOYEE_FETCH, context.getters.currentUser.id)
        }
      })
      .catch(({
        response
      }) => {
        if (response.status === 401) {
          context.dispatch(LOGOUT).then(() => {
            router.push({
              name: 'pageLogin'
            })
          })
        }
      })
  },
  async [USER_DATA_UPDATE](context, payload) {
    await AuthService.updateUser(payload.id, payload)
      .then(({
        data
      }) => {

      })
      .catch(({
        response
      }) => {

      })
  },
  async [USER_BANK_CARD_CREATE](context, payload) {
    await AuthService.createUserCard(payload)
      .then(({
        data
      }) => {
        payload.notify({
          title: 'Новая карта успешно привязана',
          text: data['message']
        })
        // context.commit(SET_USER_BANK_CARD, data)
      })
      .catch(({
        response
      }) => {
        payload.notify({
          title: 'Не удалось прикрепить банковскую карту',
          text: response.data
        })
      })
  },
  async [USER_BANK_CARD_UPDATE](context, payload) {
    await AuthService.updateUserCard(payload)
      .then(({
        data
      }) => {
        payload.notify({
          title: 'Карта успешно обновлена',
          text: data['message']
        })
      })
      .catch(({
        response
      }) => {
        payload.notify({
          title: 'Не удалось обновить банковскую карту',
          text: response.data
        })
      })
  },
  async [USER_BANK_ACCOUNT_CREATE](context, payload) {
    await AuthService.createUserBankAccount(payload)
      .then(({
        data
      }) => {
        payload.notify({
          title: 'Новый банковский счет успешно привязан',
          text: data['message']
        })
        context.commit(SET_USER_BANK_ACCOUNT, payload)
      })
      .catch(({
        response
      }) => {
        payload.notify({
          title: 'Не удалось прикрепить банковский счет',
          text: response.data.error
        })
      })
  },
  async [USER_BANK_ACCOUNT_UPDATE](context, payload) {
    await AuthService.updateUserBankAccount(payload)
      .then(({
        data
      }) => {
        payload.notify({
          title: 'Банковский счёт успешно обновлен',
          text: data['message']
        })
        context.commit(SET_USER_BANK_ACCOUNT, payload)
      })
      .catch(({
        response
      }) => {
        payload.notify({
          title: 'Не удалось обновить банковский счет',
          text: response.data.error
        })
      })
  }

}
